import { localStorageOperations, userInfo } from '@utility';
import { getObjectValue } from '@utility/utills';

export const GET_OAUTH_REQUESTED = 'controller/GET_OAUTH_REQUESTED';
export const GET_OAUTH_SUCCESS = 'controller/GET_OAUTH_SUCCESS';
export const GET_OAUTH_FAILURE = 'controller/GET_OAUTH_FAILURE';

export const POP_IN_REQUESTED = 'controller/POP_IN_REQUESTED';
export const POP_IN_SUCCESS = 'controller/POP_IN_SUCCESS';
export const POP_IN_FAILURE = 'controller/POP_IN_FAILURE';

export const SENSOR_CHECK_IN_REQUESTED = 'controller/SENSOR_CHECK_IN_REQUESTED';
export const SENSOR_CHECK_IN_SUCCESS = 'controller/SENSOR_CHECK_IN_SUCCESS';
export const SENSOR_CHECK_IN_FAILURE = 'controller/SENSOR_CHECK_IN_FAILURE';

export const UPDATE_POP_IN_REQUESTED = 'controller/UPDATE_POP_IN_REQUESTED';
export const UPDATE_POP_IN_SUCCESS = 'controller/UPDATE_POP_IN_SUCCESS';

export const POP_IN_BLANK_REQUESTED = 'controller/POP_IN_BLANK_REQUESTED';
export const POP_IN_BLANK_SUCCESS = 'controller/POP_IN_BLANK_SUCCESS';
export const POP_IN_BLANK_FAILURE = 'controller/POP_IN_BLANK_FAILURE';

export const LEAVE_TABLE_REQUESTED = 'controller/LEAVE_TABLE_REQUEST';
export const LEAVE_TABLE_SUCCESS = 'controller/LEAVE_TABLE_SUCCESS';
export const LEAVE_TABLE_FAILURE = 'controller/LEAVE_TABLE_FAILURE';

export const ASSIGN_SPOT_REQUESTED = 'controller/ASSIGN_SPOT_REQUEST';
export const ASSIGN_SPOT_SUCCESS = 'controller/ASSIGN_SPOT_SUCCESS';
export const ASSIGN_SPOT_FAILURE = 'controller/ASSIGN_SPOT_FAILURE';

export const SESSION_TRACK_REQUESTED = 'controller/SESSION_TRACK_REQUEST';
export const SESSION_TRACK_SUCCESS = 'controller/SESSION_TRACK_SUCCESS';
export const SESSION_TRACK_FAILURE = 'controller/SESSION_TRACK_FAILURE';

export const REVALIDATION_DATA_REQUESTED = 'controller/REVALIDATION_DATA_REQUESTED';
export const REVALIDATION_DATA_SUCCESS = 'controller/REVALIDATION_DATA_SUCCESS';
export const REVALIDATION_DATA_FAILURE = 'controller/REVALIDATION_DATA_FAILURE';

export const TABLE_ASSIGNMENT_REQUESTED = 'controller/TABLE_ASSIGNMENT_REQUESTED';
export const TABLE_ASSIGNMENT_SUCCESS = 'controller/TABLE_ASSIGNMENT_SUCCESS';
export const TABLE_ASSIGNMENT_FAILURE = 'controller/TABLE_ASSIGNMENT_FAILURE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  popInData: JSON.parse(window.sessionStorage.getItem('popIn')),
  popInRequestInfo: JSON.parse(window.localStorage.getItem('popInRequest')),
  userdata: null,
  isUserLogin: false,
  checkInStoreInfo: null,
  revalidationResponse: null,
  themeProperties: JSON.parse(window.sessionStorage.getItem('themeProperties')) || {},
  variableProperties: {}
};
const removeTheme = () => {
  try {
    const prevStyle = document.getElementById('themingStyleSheet');
    if (prevStyle) {
      prevStyle.parentNode.removeChild(prevStyle);
    }
    const prevHeaderScriptUrl = document.getElementById('headerScriptUrl');
    if (prevHeaderScriptUrl) {
      prevHeaderScriptUrl.parentNode.removeChild(prevHeaderScriptUrl);
    }
  } catch (e) {
    // console.log(e);
  }
};

const updateTheme = (res) => {
  removeTheme();

  /* eslint-disable */
  const popIn = JSON.parse(window.sessionStorage.getItem('popIn')) || null;
  const brandId = getObjectValue(() => popIn.store.brandId, 0)
  if (popIn && (brandId === 10000003) && getObjectValue(() => popIn.flowType, false) !== 2 && HOSTNAME.indexOf('.dev.') === -1) {
    document.getElementById('facebookPixcel').innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('dataProcessingOptions', ['LDU'], 0, 0);fbq('init', '1222348444600337');fbq('track', 'PageView');`;
  } else if (document.getElementById('facebookPixcel')) {
    document.getElementById('facebookPixcel').innerText = ``;
  }
  /* enable-disable */

  /* eslint-disable */
  if (popIn && getObjectValue(() => popIn.store.id, 0) === 10000092) {
    document.getElementById('gTag2').innerText = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-MD768K6');`;
  } else if (document.getElementById('gTag2')) {
    document.getElementById('gTag2').innerText = ``;
  }

  // remove googleBodyTag (if any )
  try {
    document.getElementById('facebookTagImg2').innerHTML = '';
    document.getElementById('facebookPixcel').innerText = '';
    if (document.getElementById('googleBodyTag')) {
      const element = document.getElementById("googleBodyTag");
      element.parentNode.removeChild(element);
    }
    if (document.getElementById('siftFraud')) {
      const element = document.getElementById("siftFraud");
      element.parentNode.removeChild(element);
    }
    if (document.getElementById('userway')) {
      const element = document.getElementById("userway");
      element.parentNode.removeChild(element);
    }
    if (document.getElementById('headerJs')) {
      const element = document.getElementById("headerJs");
      element.parentNode.removeChild(element);
    }
    if (document.getElementById('facebookPixcelNonse')) {
      const element = document.getElementById("facebookPixcelNonse");
      element.parentNode.removeChild(element);
    }
  } catch (e) {
    // console.log(e);
  }
  if (popIn && (brandId === 10000087)) {
    let gT = document.createElement('script');
    gT.src = 'https://www.googletagmanager.com/gtag/js?id=AW-954642213';
    gT.id = "googleBodyTag";
    gT.async = true;
    document.getElementsByTagName('body')[0].appendChild(gT);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'AW-954642213');

    document.getElementById('facebookTagImg2').innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=817376102452997&ev=PageView&noscript=1" />`;
    document.getElementById('facebookPixcel').innerText = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '817376102452997');
    fbq('track', 'PageView');`;
  }

  if (popIn && (brandId === 10000245)) {
    let gT = document.createElement('script');
    gT.src = 'https://www.googletagmanager.com/gtag/js?id=UA-161437660-1';
    gT.id = "googleBodyTag";
    gT.async = true;
    document.getElementsByTagName('body')[0].appendChild(gT);
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-161437660-1');

    document.getElementById('facebookTagImg2').innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=576955216240958&ev=PageView&noscript=1" />`;
    document.getElementById('facebookPixcel').innerText = `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '576955216240958');
    fbq('track', 'PageView');`;
  }
  
  if (res.styleUrl) {
    const css = document.createElement('link');
    css.type = 'text/css';
    css.id = 'themingStyleSheet';
    css.href = `${res.styleUrl}?date=${new Date()}`;
    css.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(css);
  }
  /* enable-disable */
  /* eslint-disable */
  try {
    document.getElementById('headerImage').innerHTML = '';
    if (document.getElementById('headerScriptUrlExe')) {
      document.getElementById('headerScriptUrlExe').parentNode.removeChild(document.getElementsById('headerScriptUrlExe'));
    }
  } catch (e) {
    // console.log(e);
  }

  /* enable-disable */
  const isUserLogin = JSON.parse(window.localStorage.getItem('isUserLogin'));
  const isIos = JSON.parse(window.localStorage.getItem('ios'));
  if (isUserLogin && getObjectValue(() => popIn.store.fraudInfo, false)) {
    const userData = JSON.parse(window.localStorage.getItem('userData'));
    const sessionId = window.sessionStorage.getItem('sessionId');
    const siftFraud = document.createElement('script');
    const _user_id = getObjectValue(() => userData.user.id, null); // Set to the user's ID, username, or email address, or '' if not yet known.
    const _session_id = sessionId || null; // Set to a unique session ID for the visitor's current browsing session.
    var _sift = window._sift = window._sift || [];
          _sift.push(['_setAccount', getObjectValue(() => popIn.store.fraudInfo.siftBeaconKey, null)]);
          _sift.push(['_setUserId', _user_id]);
          _sift.push(['_setSessionId', _session_id]);
          _sift.push(['_trackPageview']);
    siftFraud.type = 'text/javascript';
    siftFraud.id = 'siftFraudId';
    siftFraud.src = `https://cdn.sift.com/s.js`;
    document.getElementsByTagName('body')[0].appendChild(siftFraud);
  }
  /* eslint-enable */

  if (popIn?.store?.accessibilityInfo !== null && popIn?.store?.accessibilityInfo?.userWayAccountId !== null && !isIos) {
    const userWayScript = document.createElement('script');
    userWayScript.setAttribute('data-account', getObjectValue(() => popIn.store.accessibilityInfo.userWayAccountId, ''));
    userWayScript.setAttribute('src', 'https://cdn.userway.org/widget.js');
    userWayScript.defer = true;
    userWayScript.setAttribute('id', 'userway');
    document.getElementsByTagName('head')[0].appendChild(userWayScript);
  }

  if (res.headerScriptTag) {
    const headerJs = document.createElement('script');
    headerJs.src = res.headerScriptTag;
    headerJs.id = 'headerJs';
    document.getElementsByTagName('head')[0].appendChild(headerJs);
  }

  if (res.headerImageTag) {
    document.getElementById('headerImage').innerHTML = `<noscript><img height="1" width="1" style="border-style:none;" alt="" src=${res.headerImageTag} /></noscript>`;
  }

  if (res.headerScriptUrl) {
    const headerScriptUrl = document.createElement('script');
    headerScriptUrl.type = 'text/javascript';
    headerScriptUrl.id = 'headerScriptUrl';
    headerScriptUrl.src = `${res.headerScriptUrl}`;
    document.getElementsByTagName('head')[0].appendChild(headerScriptUrl);
  }

  if (res && getObjectValue(() => JSON.parse(res.headerMetaTag), null)) {
    const metaResponse = JSON.parse(res.headerMetaTag);
    const data = document.createElement('meta');
    data.name = getObjectValue(() => metaResponse.name, '');
    data.content = getObjectValue(() => metaResponse.content, '');
    document.getElementsByTagName('head')[0].appendChild(data);
  }

  /* eslint-disable */
};
const getCheckHeaderId = (data) => {
  let result = null;
  const popInData = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('popIn'), null));
  if (popInData?.checkHeaderId === 0 && popInData?.checkHeader) {
    result = null;
  } else if (popInData?.checkHeader) {
    result = popInData.checkHeader.id;
  } else if (popInData?.checkHeaderId) {
    result = popInData.checkHeaderId;
  } else if (data?.data?.checkHeader) {
    result = data?.data?.checkHeader?.id;
  }
  return result;
};

// OMW-4025  Helper function to handle new_ui_requested error
// const handleNewUiRequestedError = () => {
//   let redirectUrl = window.location.href;
//   if (redirectUrl.includes('app.uat.')) {
//     redirectUrl = redirectUrl.replace('app.uat.', 'appnew.uat.');
//   } else if (redirectUrl.includes('app.onedine.com')) {
//     redirectUrl = redirectUrl.replace('app.onedine.com', 'appnew.onedine.com');
//   }
//   window.location.href = redirectUrl;
// };
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OAUTH_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case GET_OAUTH_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        userdata: action.result,
      };
    }
    case GET_OAUTH_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case ASSIGN_SPOT_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case ASSIGN_SPOT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case ASSIGN_SPOT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case SENSOR_CHECK_IN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case SENSOR_CHECK_IN_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        checkInStoreInfo: action.result,
      };
    }
    case SENSOR_CHECK_IN_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case POP_IN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case POP_IN_SUCCESS: {
      window.sessionStorage.setItem('popIn', JSON.stringify(action.result));
      localStorageOperations.removeItem('tip');
       window.sessionStorage.setItem('themeProperties', JSON.stringify(action?.result?.theme));
      updateTheme(action?.result?.theme);
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        popInData: action.result,
        popInRequestInfo: action.payload,
        themeProperties: action?.result?.theme,
        variableProperties: action?.result?.theme?.appCustomization ? JSON.parse(action.result.theme.appCustomization || {}) : {}
      };
    }
    case POP_IN_FAILURE: {
      // Handle new_ui_requested error for URL switching
      // if (action.error?.code === 'new_ui_requested') {
      //   handleNewUiRequestedError();
      // }

      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case UPDATE_POP_IN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case UPDATE_POP_IN_SUCCESS: {
      const nextPopIn = { ...JSON.parse(window.sessionStorage.getItem('popIn')), ...action.payload };
      window.sessionStorage.setItem('popIn', JSON.stringify(nextPopIn));
      action.resolve();
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        popInData: nextPopIn,
        popInRequestInfo: action.payload
      };
    }
    case POP_IN_BLANK_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case POP_IN_BLANK_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }
    case POP_IN_BLANK_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }
    case LEAVE_TABLE_REQUESTED:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case LEAVE_TABLE_SUCCESS:
      window.sessionStorage.removeItem('popIn');
      window.sessionStorage.removeItem('themeStyle');
      return {
        ...state,
        popInData: null,
        popInRequestInfo: null,
        loading: false,
        loaded: true,
      };
    case LEAVE_TABLE_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: false
      };
    case SESSION_TRACK_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case SESSION_TRACK_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }
    case SESSION_TRACK_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: true
      };
    }
    case REVALIDATION_DATA_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case REVALIDATION_DATA_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        revalidationResponse: action.result,
      };
    }
    case REVALIDATION_DATA_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    case TABLE_ASSIGNMENT_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
    case TABLE_ASSIGNMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case TABLE_ASSIGNMENT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true
      };
    }
    default:
      return state;
  }
};


export const getOauth = (data) => {
  return {
    types: [GET_OAUTH_REQUESTED, GET_OAUTH_SUCCESS, GET_OAUTH_FAILURE],
    promise: client => client.post('getOauth', {
      data
    })
  };
};

export const getPopIn = (data) => {
  return {
    types: [POP_IN_REQUESTED, POP_IN_SUCCESS, POP_IN_FAILURE],
    promise: client => client.post('getPopIn', {
      data
    }),
    payload: data
  };
};

export const getPreviewPopIn = (data) => {
  return {
    types: [POP_IN_REQUESTED, POP_IN_SUCCESS, POP_IN_FAILURE],
    promise: client => client.post('getPreviewPopIn', {
      data
    }),
    payload: data
  };
};

export const sensorCheckIn = (data) => {
  return {
    types: [SENSOR_CHECK_IN_REQUESTED, SENSOR_CHECK_IN_SUCCESS, SENSOR_CHECK_IN_FAILURE],
    promise: client => client.post('sensorCheckIn', {
      data
    }),
    payload: data
  };
};


export const getPopInBlank = (data) => {
  return {
    types: [POP_IN_REQUESTED, POP_IN_SUCCESS, POP_IN_FAILURE],
    promise: client => client.post('getPopInblank', {
      data
    }),
    payload: data
  };
};

export const updatePopInData = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: UPDATE_POP_IN_REQUESTED
      });
      setTimeout(() => {
        dispatch({
          type: UPDATE_POP_IN_SUCCESS,
          payload: data,
          resolve,
          reject
        });
      }, 300);
    });
  };
};

export const leaveTable = (checkInId) => {
  return {
    types: [LEAVE_TABLE_REQUESTED, LEAVE_TABLE_SUCCESS, LEAVE_TABLE_FAILURE],
    promise: client => client.post(`checkoutTable/${checkInId}`)
  };
};

export const assignSpot = (data) => {
  return {
    types: [ASSIGN_SPOT_REQUESTED, ASSIGN_SPOT_SUCCESS, ASSIGN_SPOT_FAILURE],
    promise: client => client.post('assignSpot', {
      data
    })
  };
};

export const clearPopInData = () => {
  return (dispatch) => {
    dispatch({
      type: LEAVE_TABLE_REQUESTED
    });
    setTimeout(() => {
      dispatch({
        type: LEAVE_TABLE_SUCCESS,
      });
    }, 300);
  };
};

export const loyaltyAccountUnAssign = (data) => {
  return {
    types: [GET_OAUTH_REQUESTED, GET_OAUTH_SUCCESS, GET_OAUTH_FAILURE],
    promise: client => client.post('loyaltyAccountUnAssign', {
      data
    })
  };
};

export const sessionTrack = (data) => {
  const dataToSend = {
    sessionId: window.sessionStorage.getItem('sessionId'),
    storeId: (getObjectValue(() => JSON.parse(window.sessionStorage.getItem('popIn')).store.id, 0)) || null,
    guestId: getObjectValue(() => window.localStorage.getItem('guestId'), null),
   memberId: userInfo.getUserBasicDetails()?.id ?? null,
   checkHeaderId: getCheckHeaderId(data),
    brandId: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('popIn')).store.brandId, 0),
    ...data
  };
  return {
    types: [SESSION_TRACK_REQUESTED, SESSION_TRACK_SUCCESS, SESSION_TRACK_FAILURE],
    promise: client => client.post('sessionTrack', {
      data: dataToSend,
    })
  };
};

export const getRevalidationData = (data) => {
  return {
    types: [REVALIDATION_DATA_REQUESTED, REVALIDATION_DATA_SUCCESS, REVALIDATION_DATA_FAILURE],
    promise: client => client.post('getRevalidationData', {
      data
    }),
    payload: data
  };
};

export const tableAssignment = (data) => {
  return {
    types: [TABLE_ASSIGNMENT_REQUESTED, TABLE_ASSIGNMENT_SUCCESS, TABLE_ASSIGNMENT_SUCCESS],
    promise: client => client.post('tableAssignment', {
      data
    }),
    payload: data
  };
};
